<template>
  <div id="box3">
    <div class="box">
      <div class="item" v-for="(item,index) in list" :key="index">
        <img :src="require(`../assets/box3/0${index + 1}.png`)" alt="" />
        <span>需要{{item.count}}个小谷币</span>
        <div class="button" @click="Exchange(item.count,index)">兑换好礼</div>
      </div>
      <div class="foot"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { getCoin } from "../api/index";
export default {
  data() {
    return {
      list: [
        {
          count: 10000,
        },
        {
          count: 6000,
        },
        {
          count: 3000,
        },
        {
          count: 1600,
        },
        {
          count: 1000,
        },
        {
          count: 600,
        },
        {
          count: 500,
        },
        {
          count: 200,
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["Openpop","Opennomore","Openmore"]),
    ...mapActions(["getCoin"]),
    async Exchange(consumenum,convertType) {
     let flag = await this.getCoin();
     if(!flag) return;
      if (this.coin >= consumenum) {
        // 如果有的小谷币比消耗的多 弹兑换
        this.Openmore({consumenum,convertType})
      } else {
        // 如果有的小谷币比消耗的少 弹小谷币不足
        this.Opennomore()
      }
    },
  },
  computed: {
    ...mapState(["coin"]),
  },
};
</script>

<style lang='scss' scoped>
.box {
  margin: 0 auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  width: 690px;
  //   height: 1942px;
  background-color: #6b00d9;
  .foot {
    width: 100%;
    height: 30px;
  }
  .item {
    margin-top: 30px;
    width: 310px;
    height: 448px;
    background-color: #9f7fff;
    border-radius: 10px;
    img {
      margin: 0 auto;
      margin-top: 10px;
      display: block;
      width: 290px;
      height: 290px;
    }
    span {
      display: block;
      margin: 15px 0;
      text-align: center;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #ffffff;
    }
    .button {
      margin: 0 auto;
      width: 260px;
      height: 66px;
      border-radius: 12px;
      background-image: url("../assets/btn.png");
      background-size: 100% 100%;
      font-family: SourceHanSansCN-Medium;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 66px;
      letter-spacing: 1px;
      color: #5530fd;
      text-align: center;
      border: solid 2px #532bff;
    }
  }
}
</style>